var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal_calificaciones",
      attrs: {
        size: "lg",
        title: "Comentarios recientes para " + _vm.empresa.nombre,
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c("b-overlay", { attrs: { show: _vm.consulta_en_progreso } }, [
        _c(
          "div",
          {
            ref: "div_modal_calificaciones",
            staticClass: "row d-flex align-items-center",
          },
          [
            _c("div", { staticClass: "col-md-3 mb-3 text-center" }, [
              _vm.empresa.logo
                ? _c("img", {
                    staticStyle: { height: "70px" },
                    attrs: {
                      id: "logo_empresa_calif",
                      alt: "Mudanzas DF",
                      src: _vm.base_url + _vm.empresa.logo,
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.estadisticas_calificaciones &&
            _vm.estadisticas_calificaciones.calificacion_promedio > 0
              ? _c("div", { staticClass: "col-md-9 mb-3" }, [
                  _c("div", { staticClass: "row d-flex align-items-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 mb-md-0 mb-3 text-center" },
                      [
                        _vm.solo_mostrar_n_calificaciones > 0 &&
                        (typeof _vm.estadisticas_calificaciones
                          .total_calificaciones == "undefined" ||
                          _vm.estadisticas_calificaciones.total_calificaciones <
                            5)
                          ? _c("span", { staticClass: "text-semibold" }, [
                              _vm._v(
                                "\n              Esta empresa aún no tiene suficientes ventas para calcular su\n              reputación\n            "
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _c("h1", { staticClass: "display-4" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.estadisticas_calificaciones
                                          .calificacion_promedio
                                      ) +
                                      "/5\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("b-form-rating", {
                                  attrs: {
                                    variant: "warning",
                                    size: "lg",
                                    "no-border": "",
                                    readonly: "",
                                  },
                                  model: {
                                    value: _vm.empresa.promedio_estrellas_real,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.empresa,
                                        "promedio_estrellas_real",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "empresa.promedio_estrellas_real",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.solo_mostrar_n_calificaciones == 0
                                  ? _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        "\n                Promedio entre\n                " +
                                          _vm._s(
                                            _vm.estadisticas_calificaciones
                                              .total_calificaciones
                                          ) +
                                          "\n                opiniones\n              "
                                      ),
                                    ])
                                  : _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        "\n                Promedio entre\n                " +
                                          _vm._s(
                                            _vm.estadisticas_calificaciones
                                              .total_calificaciones
                                          ) +
                                          "\n                opiniones recibidas en los últimos\n                " +
                                          _vm._s(
                                            _vm.estadisticas_calificaciones
                                              .meses_calificacion_reciente
                                          ) +
                                          "\n                meses\n              "
                                      ),
                                    ]),
                              ],
                              1
                            ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _vm.estadisticas_calificaciones
                        .cantidad_calificaciones_5_estrella > 0
                        ? _c(
                            "div",
                            { staticClass: "row d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("5 estrellas"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("b-progress", {
                                    attrs: {
                                      height: "4px",
                                      value:
                                        (_vm.estadisticas_calificaciones
                                          .cantidad_calificaciones_5_estrella *
                                          100) /
                                        _vm.estadisticas_calificaciones
                                          .total_calificaciones,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-2 text-left" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.estadisticas_calificaciones
                                        .cantidad_calificaciones_5_estrella
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.estadisticas_calificaciones
                        .cantidad_calificaciones_4_estrella > 0
                        ? _c(
                            "div",
                            { staticClass: "row d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("4 estrellas"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("b-progress", {
                                    attrs: {
                                      height: "4px",
                                      value:
                                        (_vm.estadisticas_calificaciones
                                          .cantidad_calificaciones_4_estrella *
                                          100) /
                                        _vm.estadisticas_calificaciones
                                          .total_calificaciones,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-2 text-left" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.estadisticas_calificaciones
                                        .cantidad_calificaciones_4_estrella
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.estadisticas_calificaciones
                        .cantidad_calificaciones_3_estrella > 0
                        ? _c(
                            "div",
                            { staticClass: "row d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("3 estrellas"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("b-progress", {
                                    attrs: {
                                      height: "4px",
                                      value:
                                        (_vm.estadisticas_calificaciones
                                          .cantidad_calificaciones_3_estrella *
                                          100) /
                                        _vm.estadisticas_calificaciones
                                          .total_calificaciones,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-2 text-left" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.estadisticas_calificaciones
                                        .cantidad_calificaciones_3_estrella
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.estadisticas_calificaciones
                        .cantidad_calificaciones_2_estrella > 0
                        ? _c(
                            "div",
                            { staticClass: "row d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("2 estrellas"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("b-progress", {
                                    attrs: {
                                      height: "4px",
                                      value:
                                        (_vm.estadisticas_calificaciones
                                          .cantidad_calificaciones_2_estrella *
                                          100) /
                                        _vm.estadisticas_calificaciones
                                          .total_calificaciones,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-2 text-left" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.estadisticas_calificaciones
                                        .cantidad_calificaciones_2_estrella
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.estadisticas_calificaciones
                        .cantidad_calificaciones_1_estrella > 0
                        ? _c(
                            "div",
                            { staticClass: "row d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("1 estrella"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("b-progress", {
                                    attrs: {
                                      height: "4px",
                                      value:
                                        (_vm.estadisticas_calificaciones
                                          .cantidad_calificaciones_1_estrella *
                                          100) /
                                        _vm.estadisticas_calificaciones
                                          .total_calificaciones,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-2 text-left" }, [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.estadisticas_calificaciones
                                        .cantidad_calificaciones_1_estrella
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ])
              : _c("div", { staticClass: "col-md-9 mb-3" }, [
                  _c("span", { staticClass: "text-semibold" }, [
                    _vm._v(
                      "\n          Esta empresa aún no tiene suficientes ventas para calcular su\n          reputación\n        "
                    ),
                  ]),
                ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-none d-md-block" }, [
          _c("div", { staticClass: "row bg-light mb-4 py-2 text-muted" }, [
            _c("div", { staticClass: "col-md-3" }, [
              _c("b", [_vm._v("Cliente")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("b", [_vm._v("Calificación")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("b", [_vm._v("Valoración")]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.calificaciones, function (c) {
            return _c("div", { key: c.id_mm }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("ul", { staticClass: "list-unstyled mb-0" }, [
                    c.solicitud && c.solicitud.nombre_cliente
                      ? _c("li", [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.abreviarApellidos(
                                  c.solicitud.nombre_cliente
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", [
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(c.cotizacion_contratada.folio_carta_porte) +
                            "-" +
                            _vm._s(c.cotizacion_contratada.id_carta_porte) +
                            "\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: {
                            title: _vm
                              .moment(c.fecha_registro)
                              .format("DD/MM/YYYY"),
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.moment(c.fecha_registro).fromNow()) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-3" },
                  [
                    _c("b-form-rating", {
                      attrs: {
                        variant: "warning",
                        "show-value": "",
                        "show-value-max": "",
                        size: "sm",
                        "no-border": "",
                        readonly: "",
                      },
                      model: {
                        value: c.calif_empresa,
                        callback: function ($$v) {
                          _vm.$set(c, "calif_empresa", $$v)
                        },
                        expression: "c.calif_empresa",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    c.comentario != ""
                      ? _c("span", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(c.comentario) +
                              "\n            "
                          ),
                        ])
                      : _c("em", { staticClass: "text-muted" }, [
                          _vm._v("No dejó comentario"),
                        ]),
                    _vm._v(" "),
                    _vm._l(c.chat, function (chat, i) {
                      return _c("div", { key: i, staticClass: "col-12 mt-3" }, [
                        _c(
                          "div",
                          {
                            class: [
                              chat.tipo_usuario == "proveedor"
                                ? "text-right bd-callout-right bd-callout-success"
                                : "bd-callout bd-callout-info",
                            ],
                          },
                          [
                            _c("ul", { staticClass: "list-unstyled mb-0" }, [
                              _c("li", [_vm._v(_vm._s(chat.comentario))]),
                              _vm._v(" "),
                              _c("li", [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.empresa.nombre) +
                                      "\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.moment(chat.created_at).fromNow()
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }